import Renderer from "./Renderer.js";

class CheckboxRenderer extends Renderer {
    render() {
        return '<input type="checkbox" value="' + this.row.id + '">';
    }
}

export default CheckboxRenderer;
